/* Global JavaScript for Esther Franchuk Fine Art theme */

(function() {
  'use strict';

  // ==========================================================================
  // CART MANAGEMENT
  // ==========================================================================

  class CartManager {
    constructor() {
      this.init();
    }

    init() {
      this.bindEvents();
      this.updateCartCount();
    }

    bindEvents() {
      // Add to cart form submission
      document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
        form.addEventListener('submit', this.handleAddToCart.bind(this));
      });

      // Cart quantity updates
      document.querySelectorAll('.cart-item__quantity-input').forEach(input => {
        input.addEventListener('change', this.handleQuantityChange.bind(this));
      });
    }

    async handleAddToCart(event) {
      event.preventDefault();
      const form = event.target;
      const formData = new FormData(form);
      const button = form.querySelector('button[type="submit"]');
      const originalButtonText = button ? button.textContent : 'Add to Cart';

      // Disable button during submission
      if (button) {
        button.disabled = true;
        button.textContent = 'Toevoegen...';
      }

      try {
        // --- START WIJZIGING 1 ---
        // We voegen .js toe aan de URL om een JSON-antwoord te forceren
        const response = await fetch(`${window.routes.cart_add_url}.js`, {
          method: 'POST',
          body: formData
        });
        // --- EINDE WIJZIGING 1 ---

        if (!response.ok) {
          // Als de response niet OK is, proberen we de foutmelding van Shopify te lezen
          const errorData = await response.json();
          throw new Error(errorData.description || 'Failed to add to cart');
        }

        await response.json(); // Wacht op het antwoord

        // --- START WIJZIGING 2 ---
        // Stuur de gebruiker direct naar de winkelwagen. Dit is de meest betrouwbare manier.
        window.location.href = '/cart';
        // --- EINDE WIJZIGING 2 ---

      } catch (error) {
        console.error('Error adding to cart:', error);
        alert(error.message || 'Error adding to cart. Please try again.'); // Toon de foutmelding
      } finally {
        // Zorg ervoor dat de knop altijd wordt hersteld, zelfs als de redirect mislukt
        if (button) {
          button.disabled = false;
          button.textContent = originalButtonText;
        }
      }
    }

    async handleQuantityChange(event) {
      const input = event.target;
      const line = input.dataset.index;
      const quantity = parseInt(input.value, 10);

      if (quantity < 0) {
        input.value = 0;
        return;
      }

      try {
        const response = await fetch(window.routes.cart_change_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            line: line,
            quantity: quantity
          })
        });

        if (!response.ok) {
          throw new Error('Failed to update cart');
        }

        // Reload page to show updated cart
        window.location.reload();
      } catch (error) {
        console.error('Error updating cart:', error);
        this.showNotification('Error updating cart. Please try again.', 'error');
      }
    }

    async updateCartCount() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        const countElement = document.querySelector('[data-cart-count]');

        if (countElement) {
          countElement.textContent = cart.item_count;
        }
      } catch (error) {
        console.error('Error fetching cart:', error);
      }
    }

    showNotification(message, type = 'success') {
      // Create notification element
      const notification = document.createElement('div');
      notification.className = `notification notification--${type}`;
      notification.textContent = message;
      notification.style.cssText = `
        position: fixed;
        top: 2rem;
        right: 2rem;
        padding: 1.5rem 2rem;
        background-color: ${type === 'success' ? '#4CAF50' : '#f44336'};
        color: white;
        border-radius: 0.5rem;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        z-index: 10000;
        animation: slideIn 0.3s ease;
      `;

      document.body.appendChild(notification);

      // Remove after 3 seconds
      setTimeout(() => {
        notification.style.animation = 'slideOut 0.3s ease';
        setTimeout(() => notification.remove(), 300);
      }, 3000);
    }
  }

  // ==========================================================================
  // SEARCH FUNCTIONALITY
  // ==========================================================================

  class SearchManager {
    constructor() {
      this.searchBar = document.querySelector('.header__search-bar');
      this.searchInput = document.querySelector('.header__search-input');
      this.searchToggle = document.querySelector('.header__icon--search');
      this.searchClose = document.querySelector('.header__search-close');

      this.init();
    }

    init() {
      if (!this.searchBar || !this.searchToggle) return;

      this.searchToggle.addEventListener('click', this.openSearch.bind(this));

      if (this.searchClose) {
        this.searchClose.addEventListener('click', this.closeSearch.bind(this));
      }

      // Close on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.searchBar.style.display === 'block') {
          this.closeSearch();
        }
      });
    }

    openSearch() {
      if (this.searchBar) {
        this.searchBar.style.display = 'block';
        if (this.searchInput) {
          this.searchInput.focus();
        }
      }
    }

    closeSearch() {
      if (this.searchBar) {
        this.searchBar.style.display = 'none';
        if (this.searchInput) {
          this.searchInput.value = '';
        }
      }
    }
  }

  // ==========================================================================
  // MOBILE MENU
  // ==========================================================================

  class MobileMenu {
    constructor() {
      this.init();
    }

    init() {
      // Add mobile menu toggle if needed
      if (window.innerWidth < 990) {
        this.createMobileMenu();
      }

      window.addEventListener('resize', () => {
        if (window.innerWidth < 990) {
          this.createMobileMenu();
        }
      });
    }

    createMobileMenu() {
      // Mobile menu implementation
      // This would be enhanced based on specific design requirements
    }
  }

  // ==========================================================================
  // IMAGE LAZY LOADING (Fallback for older browsers)
  // ==========================================================================

  class LazyLoader {
    constructor() {
      this.init();
    }

    init() {
      if ('loading' in HTMLImageElement.prototype) {
        // Browser supports native lazy loading
        return;
      }

      // Fallback for browsers that don't support lazy loading
      const images = document.querySelectorAll('img[loading="lazy"]');

      if ('IntersectionObserver' in window) {
        const imageObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const img = entry.target;
              img.src = img.dataset.src || img.src;
              img.removeAttribute('loading');
              imageObserver.unobserve(img);
            }
          });
        });

        images.forEach(img => imageObserver.observe(img));
      } else {
        // Very old browser fallback - just load all images
        images.forEach(img => {
          img.src = img.dataset.src || img.src;
        });
      }
    }
  }

  // ==========================================================================
  // SMOOTH SCROLL
  // ==========================================================================

  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        const href = this.getAttribute('href');

        if (href === '#') return;

        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  }

  // ==========================================================================
  // FORM VALIDATION
  // ==========================================================================

  function initFormValidation() {
    const forms = document.querySelectorAll('form[data-validate]');

    forms.forEach(form => {
      form.addEventListener('submit', function(e) {
        const emailInputs = form.querySelectorAll('input[type="email"]');
        let isValid = true;

        emailInputs.forEach(input => {
          if (!validateEmail(input.value)) {
            isValid = false;
            input.classList.add('error');
            showFieldError(input, 'Please enter a valid email address');
          } else {
            input.classList.remove('error');
            hideFieldError(input);
          }
        });

        if (!isValid) {
          e.preventDefault();
        }
      });
    });
  }

  function validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }

  function showFieldError(input, message) {
    let errorElement = input.parentElement.querySelector('.field-error');

    if (!errorElement) {
      errorElement = document.createElement('span');
      errorElement.className = 'field-error';
      errorElement.style.cssText = 'color: red; font-size: 1.2rem; margin-top: 0.5rem; display: block;';
      input.parentElement.appendChild(errorElement);
    }

    errorElement.textContent = message;
  }

  function hideFieldError(input) {
    const errorElement = input.parentElement.querySelector('.field-error');
    if (errorElement) {
      errorElement.remove();
    }
  }

  // ==========================================================================
  // INITIALIZATION
  // ==========================================================================

  function init() {
    // Initialize all modules when DOM is ready
    new CartManager();
    new SearchManager();
    new MobileMenu();
    new LazyLoader();
    initSmoothScroll();
    initFormValidation();
  }

  // Run initialization when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Add CSS animations
  const style = document.createElement('style');
  style.textContent = `
    @keyframes slideIn {
      from {
        transform: translateX(100%);
        opacity: 0;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }

    @keyframes slideOut {
      from {
        transform: translateX(0);
        opacity: 1;
      }
      to {
        transform: translateX(100%);
        opacity: 0;
      }
    }
  `;
  document.head.appendChild(style);

})();